import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function ClimateSecureBaseline() {
  return (
    <div className="art-page">
      <SEO
        title="Baseline Study and KPT Survey — Climate Secure India"
        description="CIRCODU conducted integrated baseline and project surveys for Climate Secure India's combined cookstove and water treatment carbon programme, providing paired design data for emissions reduction calculations."
        keywords="Climate Secure, baseline study, KPT survey, cookstove, water treatment, carbon programme, integrated monitoring, carbon finance, emissions reduction, clean energy, Uganda, carbon project development, paired design survey, counterfactual data, carbon verification, CIRCODU, Climate Secure baseline Uganda, cookstove baseline Uganda, water treatment baseline Uganda, integrated carbon programme Uganda"
        url="/Baseline-Study-and-KPT-Survey—Improved-Cookstoves-and-Water-Treatment-Filters-Climate-Secure-India"
        datePublished="2021-12-20"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Baseline Study and KPT Survey — Improved Cookstoves and Water
              Treatment Filters (Climate Secure India)
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              December 20, 2021
            </div>
            <h1 className="art-title">
              Baseline Study and KPT Survey — Improved Cookstoves and Water
              Treatment Filters (Climate Secure India)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In December 2021, CIRCODU conducted a combined baseline and
                project survey for{" "}
                <strong>Climate Secure India Private Limited</strong>, covering
                both improved cookstoves and household water treatment filters
                across Uganda. The study was designed to provide the baseline
                and project-period data needed to support a carbon finance
                programme spanning two clean technology types — an integrated
                approach that sought to maximise social and environmental impact
                by linking cooking and water treatment improvements within a
                single monitoring framework.
              </p>
              <p>
                Integrated carbon programmes combining cookstoves and clean
                water technologies are increasingly recognised as an efficient
                model for maximising impact per carbon credit generated, since
                both interventions address overlapping household health burdens
                and can be monitored using comparable field methodologies.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU deployed survey teams to conduct structured interviews
                and assessments in both <strong>baseline households</strong> —
                those not yet using the improved technologies — and{" "}
                <strong>project households</strong> already using the cookstoves
                and water filters. This paired design allowed direct comparison
                of fuel consumption, cooking practices, and water treatment
                behaviours between the two groups, establishing the
                counterfactual needed to calculate credible emissions reductions
                and health impact metrics for carbon verification purposes.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's carbon baseline surveys,
                contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
